import { render, staticRenderFns } from "./transportStatistics.vue?vue&type=template&id=745efb8b&scoped=true"
import script from "./transportStatistics.vue?vue&type=script&lang=js"
export * from "./transportStatistics.vue?vue&type=script&lang=js"
import style0 from "./transportStatistics.vue?vue&type=style&index=0&id=745efb8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745efb8b",
  null
  
)

export default component.exports